import type {FC} from 'react'
import {useEffect} from 'react'
import {useParams} from 'react-router'
import {useQuery} from 'react-query'
import {PageTitle} from '../../../../_metronic/layout/core'
import {getTransactionRecordById} from '../../../modules/services/transactions.service'
import {getBreadCrumbs} from '../breadcrumbs'
import { convertToRupiah } from '../../../../_metronic/helpers/currency'

const EnablerDetailPage: FC = () => {
  const {id} = useParams<{id: string}>()
  const {data} = useQuery(['getTransactionRecordById', id], () => getTransactionRecordById(id))

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])
  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Shopee Transaction - Detail</p>
          </div>
        </div>
        <div className='col d-flex flex-column gap-4 p-8'>
          <div className='row'>
            <h4 className='fs-6 fw-bold'>SKU :</h4>
            <p className='fs-6 ms-8'>{data?.data.attributes.SKU}</p>
          </div>
          <div className='row'>
            <h4 className='fs-6 fw-bold'>Price :</h4>
            <p className='fs-6 ms-8'>{convertToRupiah(data?.data?.attributes?.price) || '-'}</p>
          </div>
          <div className='row'>
            <h4 className='fs-6 fw-bold'>Username :</h4>
            <p className='fs-6 ms-8'>{data?.data.attributes.username}</p>
          </div>
          <div className='row'>
            <h4 className='fs-6 fw-bold'>Qty :</h4>
            <p className='fs-6 ms-8'>{data?.data.attributes.quantity} pcs</p>
          </div>
          <div className='row'>
            <h4 className='fs-6 fw-bold'>Product Name :</h4>
            <p className='fs-6 ms-8'>{data?.data.attributes.productName}</p>
          </div>
          <div className='row'>
            <h4 className='fs-6 fw-bold'>Transaction ID :</h4>
            <p className='fs-6 ms-8'>{data?.data.attributes.orderNumber}</p>
          </div>
          <div className='row'>
            <h4 className='fs-6 fw-bold'>Order Date :</h4>
            <p className='fs-6 ms-8'>{data?.data.attributes.orderDate?.substring(0, 10)||'-'} { data?.data.attributes.orderDate?.substring(11, 16) || '-'}</p>
          </div>
          <div className='row'>
            <h4 className='fs-6 fw-bold'>Payment Date :</h4>
            <p className='fs-6 ms-8'>{data?.data.attributes.paymentDate?.substring(0, 10)||'-'} {data?.data.attributes.paymentDate?.substring(11, 16) || '-'}</p>
          </div>
          <div className='row'>
            <h4 className='fs-6 fw-bold'>Shipping Date :</h4>
            <p className='fs-6 ms-8'>{data?.data.attributes?.shippingDate?.substring(0, 10)||'-'} {data?.data.attributes.shippingDate?.substring(11, 16) || '-'}</p>
          </div>
          <div className='row'>
            <h4 className='fs-6 fw-bold'>Finish Date :</h4>
            <p className='fs-6 ms-8'>{data?.data.attributes.finishedDate?.substring(0, 10)||'-'} {data?.data.attributes.finishedDate?.substring(11, 16) || '-'}</p>
          </div>
          
        </div>
      </div>
    </>
  )
}

const EnablerDetailWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('/enabler')}>Enabler</PageTitle>
      <EnablerDetailPage />
    </>
  )
}

export default EnablerDetailWrapper
